import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== "production";

import {
  categoryList
} from '@/api/api.js'

// state 存放状态
// mutations state成员操作
// getters 加工state成员给外界
// actions 异步操作
// modules 模块化状态管理

export default new Vuex.Store({
  // modules,
  state: {
    name: 'Vuex',
    baseDataRouter: []
  },
  mutations: {
    editName(state, val) {
      state.name = val;
    },
    setBaseData(state, baseDataRouter) {
      state.baseDataRouter = baseDataRouter
    }
  },
  actions: {
    aEdit(context, payload) {
      context.commit('editName', payload)
    },
    getBaseDataRouter({
      state,
      commit
    }) {
      commit('setBaseData');
      return new Promise(resolve => {
        let _json = {
          code: "category_list",
          whereData: {
            type: 6
          }
        }
        categoryList(_json).then(res => {
          commit('setBaseData', JSON.parse(JSON.stringify(res)));
          resolve(JSON.parse(JSON.stringify(res)))
        })
      }).catch(() => {
        resolve(null)
      });
    }
  },
  getters: {
    getCategory: state => {
      return state.baseDataRouter.filter(item => item.status)
    },

    getNavHeader: state => {
      let baseDataRouter = JSON.parse(JSON.stringify(state.baseDataRouter))
      let navMenu = baseDataRouter.filter(item => item.status && item.level === 1)
      navMenu.map(item => {
        item.children = baseDataRouter.filter(iitem => iitem.status && iitem.level === 2 && item.id == iitem
          .pid)
      })
      navMenu.map(item => {
        item.children.map(iitem => {
          iitem.children = baseDataRouter.filter(iiitem => iiitem.status && iiitem.level === 3 && iitem
            .id == iiitem.pid)
        })
      })
      return navMenu
    },
    getNavFooter: state => {
      let baseDataRouter = JSON.parse(JSON.stringify(state.baseDataRouter))
      let navMenu = baseDataRouter.filter(item => item.status && item.level === 1)
      navMenu.map(item => {
        item.children = baseDataRouter.filter(iitem => iitem.status && item.id == iitem.topId)
      })
      navMenu.map(item => {
        let isLevel3 = false
        item.children.map(iitem => {
          if (iitem.level === 3) {
            isLevel3 = true
          }
        })
        if (isLevel3) {
          item.children = item.children.filter(iitem => iitem.level === 3)
        }
      })
      console.log('footer', navMenu)
      return navMenu
    },

    getCategoryProduct: state => {
      return state.baseDataRouter.filter(item => item.status && item.pid == 774)
    },
  },
  strict: debug
});


// export default {
// 	token: state => state.app.token,
// 	isLogin: state => !!state.app.token,
// 	backgroundColor: state => state.app.backgroundColor,
// 	userInfo: state => state.app.userInfo || {},
// 	uid: state => state.app.uid,
// 	homeActive: state => state.app.homeActive,
// 	home: state => state.app.home,
// 	chatUrl: state => state.app.chatUrl,
// 	authorizeType: state => state.app.authorizeType,
// 	httpImg: state => state.app.httpImg
// };



// WEBPACK FOOTER //
// ./src/store/index.js